import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutSuccess } from "../redux/crmAdminAuthSlice";
import PlayerPage from "../components/CrmPlayerPage";
import GiftPage from "../components/CrmGiftPage";
import CallingRequestsPage from "../components/CrmCallingRequests";

const CrmLanding = () => {
  const [activeMenu, setActiveMenu] = useState("player");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutSuccess());
    navigate("/crm-login");
  };
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/crm-login");
    }
  }, [isAuthenticated, navigate]);
  // Styles
  const containerStyle = {
    fontFamily: "'Arial', sans-serif",
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#fff",
    position: "relative",
  };

  const headerStyle = {
    position: "absolute",
    top: "0",
    right: "0",
    padding: "10px 20px",
    zIndex: 1000,
  };

  const logoutButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#ff4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#cc0000",
    },
  };

  const menuStyle = {
    width: "200px",
    backgroundColor: "#e5efe4",
    padding: "20px",
    boxShadow: "2px 0 4px rgba(0, 0, 0, 0.1)",
    position: "sticky",
    top: 0,
    height: "100vh",
  };

  const buttonStyle = (menu) => ({
    width: "100%",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    backgroundColor: activeMenu === menu ? "#50868f" : "transparent",
    color: activeMenu === menu ? "#fff" : "#333",
    cursor: "pointer",
    fontSize: "16px",
    textAlign: "left",
    marginBottom: "10px",
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: activeMenu === menu ? "#50868f" : "#d5e5d4",
    },
  });

  const contentStyle = {
    flex: 1,
    padding: "20px",
    backgroundColor: "#f8f5f2",
    borderRadius: "5px",
    margin: "20px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    minHeight: "calc(100vh - 40px)",
  };

  return (
    <div style={containerStyle}>
      {/* Logout Button - Top Right Corner */}
      <div style={headerStyle}>
        <button
          onClick={handleLogout}
          style={logoutButtonStyle}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#cc0000")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#ff4444")}
        >
          Logout
        </button>
      </div>

      {/* Sidebar Menu */}
      <div style={menuStyle}>
        <button
          style={buttonStyle("player")}
          onClick={() => setActiveMenu("player")}
        >
          Player
        </button>
        <button
          style={buttonStyle("gift")}
          onClick={() => setActiveMenu("gift")}
        >
          Gift
        </button>
        <button
          style={buttonStyle("calling-requests")}
          onClick={() => setActiveMenu("calling-requests")}
        >
          Calling Requests
        </button>
      </div>

      {/* Content Area */}
      <div style={contentStyle}>
        {activeMenu === "player" && <PlayerPage />}
        {activeMenu === "gift" && <GiftPage />}
        {activeMenu === "calling-requests" && <CallingRequestsPage />}
      </div>
    </div>
  );
};

export default CrmLanding;
